<template>
    <div>
        <div
            id="map"
            ref="map-root"
            style="height: 75vh; border: 1px solid var(--ll-border); background: var(--ll-surface);"
            :style="{'height': this.$vuetify.breakpoint.xs ? '65vh' : '75vh'}"
            class="mb-2"
        />
        <div v-if="this.$vuetify.breakpoint.smAndUp">
            <v-dialog
                v-model="dialog"
                max-width="500px"
                persistent
                scrollable
                class="ticketsfounddialog"
            >
                <v-card>
                    <v-toolbar>
                        <v-toolbar-title>
                            {{ ticketsFound.length }} Tickets Found
                        </v-toolbar-title>
                        <v-spacer />
                        <v-btn
                            icon
                            @click="dialog = false"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-simple-table
                            fixed-header
                            height="300px"
                        >
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>
                                            Ticket
                                        </th>
                                        <th>Code</th>
                                        <th>Priority</th>
                                        <th>Type</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="ticket in ticketsFound"
                                        :key="ticket.tid"
                                    >
                                        <td>
                                            <router-link
                                                :to="'/tickets/details?tid='+ ticket.tid"
                                style="text-decoration: none; color: var(--ll-link)"
                                            >
                                                {{ ticket.ticket
                                                }}-{{
                                                    ticket.revision
                                                }}
                                            </router-link>
                                        </td>
                                        <td>{{ ticket.member_code }}</td>
                                        <td>
                                            <v-icon
                                                small
                                                :color="priorityIconColor(ticket.priority)"
                                            >
                                                {{ priorityIcon(ticket.priority) }}
                                            </v-icon> {{ ticket.priority }}
                                        </td>
                                        <td>{{ ticket.type }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
        <div v-else>
            <v-bottom-sheet
                v-model="dialog"
                scrollable
                max-width="90%"
            >
                <v-card>
                    <v-card-title>
                        {{ ticketsFound.length }} Tickets Found
                    </v-card-title>
                    <v-card-text>
                        <v-divider class="mx-4" />
                        <v-data-iterator
                            :items="ticketsFound"
                            hide-default-footer
                            class="pb-2"
                        >
                            <template v-slot:default="props">
                                <div
                                    v-for="item in props.items"
                                    :key="item.tid"
                                    dense
                                    scrollable
                                >
                                    <v-card
                                        flat
                                        tile
                                        class="px-6 py-6"
                                    >
                                        <v-row
                                            class="ticket-card-ticket-revision"
                                        >
                                            <router-link
                                                :to="'/tickets/details?tid='+item.tid"
                                            >
                                                {{ item.ticket }}-{{ item.revision }}
                                            </router-link>
                                        </v-row>
                                        <v-row class="font-weight-bold">
                                            {{ item.member_code }}
                                            <v-spacer />
                                            <router-link
                                                :to="'/tickets/details?tid='+item.tid"
                                                class="text-decoration-none font-weight-bold"
                                            >
                                                <v-icon>
                                                    chevron_right
                                                </v-icon>
                                            </router-link>
                                        </v-row>
                                        <v-row>
                                            <v-col
                                                col-xs-4
                                                class="ticketCols"
                                            >
                                                <v-icon
                                                    small
                                                    :color="priorityIconColor(item.priority)"
                                                >
                                                    {{ priorityIcon(item.priority) }}
                                                </v-icon> {{ item.priority }}
                                            </v-col>
                                            <v-col
                                                col-xs-4
                                                class="ticketCols"
                                            >
                                                {{ item.type }}
                                            </v-col>
                                            <v-spacer />
                                        </v-row>
                                    </v-card>
                                    <v-divider class="mx-4" />
                                </div>
                            </template>
                        </v-data-iterator>
                    </v-card-text>
                </v-card>
            </v-bottom-sheet>
        </div>
    </div>
</template>

<script>

import {Style, Stroke, Fill, Text, Circle, RegularShape} from 'ol/style';

import 'ol/ol.css';
import {Map, View, Overlay, Feature, PluggableMap} from 'ol' ;
import * as coordinate from 'ol/coordinate';
import * as control from 'ol/control';
import * as events from 'ol/events';
import * as extent from 'ol/extent';
import * as format from 'ol/format';
import * as geom from 'ol/geom';
import * as interaction from 'ol/interaction';
import * as layer from 'ol/layer';
import * as proj from 'ol/proj';
import * as render from 'ol/render';
import * as reproj from 'ol/reproj';
import * as source from 'ol/source';
import * as sphere from 'ol/sphere';
import * as style from 'ol/style';
import * as tilegrid from 'ol/tilegrid';
import * as webgl from 'ol/webgl';
import * as turf from '@turf/turf';

import '@/components/Map/QMOL.css';
import Compass from '@/assets/compass-rose.png';
import Logo from '@/components/Map/QMOL_Logo.png';
import QMOL_Data from '@/components/Map/QMOL_Data.js';
import {quickMap} from '@/components/Map/QMOL.js';

export default {
    name: 'MapContainer',
    props: {
        state: {
            type: String,
            default: '',
        },
        county: {
            type: String,
            default: '',
        },
        source: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            qm: null,
            features: {},
            text: 'maps',
            dialog: false,
            ticketsFound: [],
        };
    },
    computed: {
        ticketMapTickets() {
            return this.$store.getters.ticketMapTickets;
        },
        states() {
            let data = this.$store.getters.companyCenters;
            let states = [];
            data.forEach(center => {
                if (states.indexOf(center.state) === -1) {
                    states.push(center.state);
                }
            });
            return states;
        },
    },
    watch: {
        county: {
            handler: function () {
                this.updateMap();
            },
            immediate: true
        },
        state: {
            handler: function () {
                this.updateMap();
            },
            immediate: true
        },
        ticketMapTickets: {
            handler: function () {
                this.updateMap();
            },
            immediate: true
        },
    },
    mounted(){
        this.qm = new quickMap(
            {
                ol: {View,Map,Overlay,Feature,PluggableMap,control,coordinate,events,extent,format,geom,interaction,layer,proj,render,reproj,source,sphere,style,tilegrid,webgl},
                turf: turf,
                target: 'map',
                compass: Compass,
                logo: Logo,
                extraData: QMOL_Data.QMOL_Data,
            }
        );

        this.qm.showDraw=false;
        this.qm.showEdit=false;
        this.qm.showDelete=false;
        this.qm.showWeather=false;
        this.qm.showMeasure=false;
        this.qm.showBullseye=false;
        this.qm.showIdentify=false;
        this.qm.showClear=false;

        document.addEventListener('qmolSingleClick', (e)=> {
            this.singleClick(e);
        });
    },
    methods: {
        updateMap() {
            const tickets = {
                type: 'FeatureCollection',
                features: [],
            };

            for (const ticket of this.ticketMapTickets){
                const fillColor=this.hexToRGBA(this.priorityIconColor(ticket.priority),0.8);
                const fillColor2=this.hexToRGBA(this.priorityIconColor(ticket.priority),0.1);
                let image, image2;
                switch (this.priorityShape(ticket.priority)) {
                    case 'circle':
                        image=new Circle({stroke:new Stroke({color:'black',width:2}),fill:new Fill({color:fillColor}),radius:8});
                        break;
                    case 'square':
                        image=new RegularShape({stroke:new Stroke({color:'black',width:2}),fill:new Fill({color:fillColor}),points:4,radius:10,angle:Math.PI/4});
                        break;
                    case 'triangle':
                        image=new RegularShape({stroke:new Stroke({color:'black',width:2}),fill:new Fill({color:fillColor2}),points:3,radius:10});
                        image2=new RegularShape({stroke:new Stroke({color:'black',width:2}),fill:new Fill({color:fillColor}),points:3,radius:10});
                        break;
                }
                tickets.features.push({
                    type: 'Feature',
                    properties: {
                        style: function(zoom){
                            return zoom<0?undefined:new Style({
                                text:new Text({text:zoom<12?'':zoom<15?ticket.ticket:`${ticket.ticket}-${ticket.revision}\n${ticket.type}`,font:'bold 12px Calibri,sans-serif',stroke:new Stroke({color:'white',width:3}),fill:new Fill({color:'black'}),offsetY:zoom<15?-15:-25}),
                                image: image
                            });
                        },
                        ticket: ticket,
                    },
                    geometry: {
                        type: 'Point',
                        coordinates: [ticket.geo_long,ticket.geo_lat]
                    }
                });
                if (ticket.priority==='EMER'){
                    tickets.features.push({
                        type: 'Feature',
                        properties: {
                            style: function(zoom){
                                return zoom<0?undefined:new Style({
                                    image: image2
                                });
                            },
                            blink: true,
                        },
                        geometry: {
                            type: 'Point',
                            coordinates: [ticket.geo_long,ticket.geo_lat]
                        }
                    });
                }
            }

            setTimeout(() => {
                this.qm.clearShow();
                this.qm.addToShow(tickets);

                if (this.state && this.county && this.county !== '*'){
                    this.qm.zoomToCounty(this.state, this.county);
                } else {
                    this.qm.zoomToShow();
                }
            }, 0);
        },
        hexToRGBA (hex, alpha) {
            return `${hex}${Math.floor(alpha * 255).toString(16).padStart(2, 0)}`;
        },
        singleClick(data){
            if (data.detail.features.length === 0) return;

            this.dialog = true;
            this.ticketsFound = [];
            for (const feature of data.detail.features.features){
                if (!feature.properties.blink){
                    this.ticketsFound.push(feature.properties.ticket);
                }
            }
            this.dialog = true;
        },
        priorityIconColor(priority) {
            switch(priority) {
                case 'NORM': case 'ROUT':
                    return '#90EE90';
                case 'RUSH': case 'SHRT': case 'INSF':
                    return '#FFA500';
                case 'EMER':
                    return '#FF0000';
                case 'NONC':
                    return '#ADD8E6';
                default:
                    return '#FFFFFF';
            }
        },
        priorityShape(priority) {
            switch(priority) {
                case 'NORM': case 'ROUT':
                    return 'circle';
                case 'RUSH': case 'SHRT': case 'INSF': case 'NONC':
                    return 'square';
                case 'EMER':
                    return 'triangle';
                default:
                    return 'circle';
            }
        },
        priorityIcon(priority) {
            switch(priority) {
                case 'NORM': case 'ROUT':
                    // gray circle exclamation
                    return 'error';
                case 'RUSH': case 'SHRT': case 'INSF':
                    // yellow circle exclamation
                    return 'error';
                case 'EMER':
                    // red bell exclamation
                    return 'notification_important';
                case 'NONC':
                    // light blue circle exclamation
                    return 'error';
                default:
                    return '';
            }
        },
        showticketsFound(event){
            if(event.detail.length > 0){
                this.ticketsFound = event.detail;
                this.dialog = true;
            }
        },
    },
};

</script>

<style scoped>
.tickets-found-dialog{
   z-index: 999999999
}
.tickets-found-dialog .v-card{
    width: 100%;
    max-width: 600px;
    margin: auto;
}
.v-sheet.v-toolbar:not(.v-sheet--outlined){
   box-shadow: 0ch;
}
.ticketCols{
    border: 1px solid rgb(207, 203, 203);
    text-align: center;
    margin-top: 4px;
    margin-bottom: 4px;
    margin-right: 4px;
    margin-left: 0px;
    padding:0px;
}
.ticket-card-ticket-revision a{
    color: #1976D2;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-decoration: none;
}
</style>
